import PatientsList from '../../../../../components/Patients/List/PatientsList';
import i18next from 'i18next';
import PatientsLogo from '../../../../../components/Shared/Icons/PatientsLogo';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import { ACCOUNT_ROUTES } from './account';
import PatientDashboard from '../../../../../components/PatientDashboard';

const PATIENT_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients',
  exact: true,
  parentRoute: ACCOUNT_ROUTES.listDS,
  additional: {
    component: PatientsList,
    protected: true,
    title: i18next.t('titles:patients'),
    icon: PatientsLogo,
  },
};

const PATIENT_ROUTE_DASHBOARD_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/:tableName/',
  exact: true,
  parentRoute: PATIENT_ROUTE_LIST_DS,
  additional: {
    component: PatientDashboard,
    protected: true,
    title: i18next.t('titles:patientDashboard'),
    icon: DashboardLogo,
  },
};

const PATIENT_ROUTE_LIST = {
  path: '/:currentAccountUuid/patients',
  exact: true,
  additional: {
    component: PatientsList,
    protected: true,
    title: i18next.t('titles:patients'),
    icon: PatientsLogo,
  },
};

const PATIENT_ROUTE_DASHBOARD = {
  path: '/:currentAccountUuid/patients/:patientUuid/:tableName/',
  exact: true,
  parentRoute: PATIENT_ROUTE_LIST,
  additional: {
    component: PatientDashboard,
    protected: true,
    title: i18next.t('titles:patientDashboard'),
    icon: DashboardLogo,
  },
};

export const PATIENT_ROUTES = {
  // ------- For child accounts ------
  listDS: PATIENT_ROUTE_LIST_DS,
  dashboardDS: PATIENT_ROUTE_DASHBOARD_DS,

  // ------- For current accounts ------
  list: PATIENT_ROUTE_LIST,
  dashboard: PATIENT_ROUTE_DASHBOARD,
};
